"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthScore = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
exports.healthScore = {
    __basic_data_type: true,
    __index_data_type: true,
    id: 'healthScore',
    title: 'Health score',
    icon: free_solid_svg_icons_1.faLightbulb,
    order: 0,
    colormap: [
        { value: 0, rgb: [255, 0, 0, 1] },
        { value: 50, rgb: [255, 190, 0, 1] },
        { value: 100, rgb: [0, 255, 0, 1] },
    ],
    indexName: 'healthScore',
};
//# sourceMappingURL=health-score.js.map